import React, { useState, useEffect } from "react";
import dhantersh2026 from "../images/MB DHAR DHANTERSH 2026 UPDATE.jpeg"

export default function AutoPopup() {

  const [open, setOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpen(true);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => setOpen(false);

  return (
    <>
      {open && (
        <div className="popup-overlay">

          <div className="popup-box">

            {/* Close Icon */}
            <span className="popup-close" onClick={closePopup}>
              ×
            </span>

            <div className="popup-content">
      <img src={dhantersh2026} className="img-fluid" alt="dhantersh2026" />
{/*      
  <iframe
      width="100%"
        height="315"
        src="https://www.youtube.com/embed/XUOZ_ls_dfk"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe> */}

              <button className="popup-btn" onClick={closePopup}>
                Close
              </button>

            </div>

          </div>

        </div>
      )}
    </>
  );
}